if ($('#user-header').length) {
    var app = new Vue({
        el: '#user-header',
        data: {
            showModal: false,
            user_id: user_id,
            result: 0,
            option: 'none',
            date: '',
            connectTitle: 'Connect',
            pointer_event: 'all',
            cursor: 'pointer',
            bg_color: '#5B45E0'
        },
        methods: {
            chooseModalAction() {
                axios.get('/api/v1/count-requests')
                    .then((response) => {
                        if (response.data && response.data.count >= 5) {
                            this.date = response.data.date;
                            this.showModal = true
                            this.option = 'block';
                        } else {
                            this.connect();
                        }
                    }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            getActions() {
                axios.get('/api/v1/get-actions', {
                    params: {
                        user_id: this.user_id
                    }
                }).then((response) => {
                    if (response.data) {
                        this.result = response.data.result;
                    }
                }).catch((error) => {
                    console.log(error);
                });
            },
            connect() {
                this.connectTitle = 'Connection request sent...';
                this.pointer_event = 'none';
                this.cursor = 'cursor';
                this.bg_color = 'rgba(91,69,224,0.57)';
                axios.post('/api/v1/connect-request', {
                    user_id: this.user_id
                }).then((response) => {
                    setTimeout(() => this.getActions(), 1500);
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            removeConnection() {
                this.connectTitle = 'Connect';
                this.pointer_event = 'all';
                this.cursor = 'pointer';
                this.bg_color = '#5B45E0';
                axios.post('/api/v1/remove-connection', {
                    user_id: this.user_id
                }).then((response) => {
                    this.getActions();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            acceptConnection() {
                axios.post('/api/v1/accept-connection', {
                    user_id: this.user_id
                }).then((response) => {
                    this.getActions();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            declineConnection() {
                axios.post('/api/v1/decline-connection', {
                    user_id: this.user_id
                }).then((response) => {
                    this.getActions();
                }).catch((error) => {
                    this.errorHandler(error);
                });
            },
            errorHandler(error) {
                if (error.response && typeof error.response.data === 'string') {
                    this.$toasted.error(error.response.data);
                } else {
                    this.$toasted.error(error.response.data.message);
                }
            },
        },
        mounted() {
            this.getActions();
        }
    });
}